"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageType = exports.PageDefinition = exports.FooterDefinition = void 0;

var _base = require("./base");

var _headerConfig = require("../components/Header/headerConfig");

var _component = require("./component");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _component.ComponentElementDefinition;
});

var HeaderDefinition = _flowRuntime["default"].tdz(function () {
  return _headerConfig.HeaderDefinition;
});

var ElementDefinition = _flowRuntime["default"].tdz(function () {
  return _base.ElementDefinition;
});

var PageType = _flowRuntime["default"].type("PageType", _flowRuntime["default"].union(_flowRuntime["default"].string("page"), _flowRuntime["default"].string("payment")));

exports.PageType = PageType;

var FooterDefinition = _flowRuntime["default"].type("FooterDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("footer")), _flowRuntime["default"].property("html", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("text", _flowRuntime["default"].string(), true))));

exports.FooterDefinition = FooterDefinition;

var PageDefinition = _flowRuntime["default"].type("PageDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("components", _flowRuntime["default"].array(_flowRuntime["default"].ref(ComponentElementDefinition))), _flowRuntime["default"].property("header", _flowRuntime["default"].ref(HeaderDefinition), true), _flowRuntime["default"].property("footer", FooterDefinition, true), _flowRuntime["default"].property("page", _flowRuntime["default"].number()), _flowRuntime["default"].property("type", PageType))));

exports.PageDefinition = PageDefinition;